// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"X1-z"};